<div class="admin-layout">
  <nav class="admin-nav">
    <mat-nav-list>
      <a mat-list-item routerLink="leagues" routerLinkActive="active-link">
        <mat-icon matListItemIcon>emoji_events</mat-icon>
        <span matListItemTitle>Leagues</span>
      </a>
      <a mat-list-item routerLink="users" routerLinkActive="active-link">
        <mat-icon matListItemIcon>people</mat-icon>
        <span matListItemTitle>Users</span>
      </a>
      <a mat-list-item routerLink="server-params" routerLinkActive="active-link">
        <mat-icon matListItemIcon>tune</mat-icon>
        <span matListItemTitle>Server params</span>
      </a>
      <a mat-list-item routerLink="uploads" routerLinkActive="active-link">
        <mat-icon matListItemIcon>cloud_upload</mat-icon>
        <span matListItemTitle>Uploads</span>
      </a>
      <a mat-list-item routerLink="sentry" routerLinkActive="active-link">
        <mat-icon matListItemIcon>bug_report</mat-icon>
        <span matListItemTitle>Sentry</span>
      </a>
    </mat-nav-list>
  </nav>
  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>
</div>
